(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-first-dark"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('slab-shop'))customElements.define('slab-shop',class extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;this.form=this.querySelector('form');this.count=1;this.button=this.querySelector('.slab-cta');this.buttonLabel=this.button.querySelector('span').textContent;this.selects=[...this.querySelectorAll('[data-slot-select]')];this.querySelectorAll('[data-photo]').forEach(b=>b.addEventListener('click',()=>this.photo(b.dataset.photo,b.dataset.alt)));this.querySelectorAll('[data-variant]').forEach(b=>b.addEventListener('click',()=>{this.selects[0].value=b.dataset.variant;this.updateColor();}));this.selects[0].addEventListener('change',()=>this.updateColor());this.querySelectorAll('[name=quantity]').forEach(r=>r.addEventListener('change',()=>{this.count=Number(r.value);this.querySelectorAll('[data-slot]').forEach((el,i)=>{el.hidden=i>=this.count;this.selects[i].disabled=i>=this.count;});this.querySelector('[data-button-price]').textContent='— '+this.money(Number(r.dataset.total));}));this.form.addEventListener('submit',e=>this.add(e));}
money(cents){return new Intl.NumberFormat(this.dataset.locale,{style:'currency',currency:this.dataset.currency}).format(cents/100);}
photo(src,alt){const img=this.querySelector('.slab-hero');if(!img)return;img.removeAttribute('srcset');img.src=src;img.alt=alt||'';}
updateColor(){const opt=this.selects[0].selectedOptions[0];this.querySelector('[data-color-name]').textContent=opt.textContent;this.querySelectorAll('[data-variant]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.variant===opt.value)));this.photo(opt.dataset.image,opt.textContent);}
async add(event){event.preventDefault();if(this.busy)return;const error=this.querySelector('.slab-error');error.hidden=true;this.busy=true;this.button.disabled=true;this.button.querySelector('span').textContent=this.dataset.adding;try{const quantities=new Map();this.selects.slice(0,this.count).forEach(s=>quantities.set(s.value,(quantities.get(s.value)||0)+1));const items=[...quantities].map(([id,quantity])=>({id:Number(id),quantity}));const response=await fetch(this.dataset.add,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});const data=await response.json();if(!response.ok||data.status>=400)throw new Error(data.description||this.dataset.error);window.location.assign(this.dataset.cart);}catch(e){error.textContent=e.message==='Failed to fetch'?this.dataset.error:e.message;error.hidden=false;this.busy=false;this.button.disabled=false;this.button.querySelector('span').textContent=this.buttonLabel;}}
});

  } catch(e) { console.error(e); }
})();
})();
